var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    className: "arrow-right_svg__fill-current arrow-right_svg__text-current arrow-right_svg__inline-block arrow-right_svg__select-none arrow-right_svg__align-text-bottom"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#041B93",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1 8h14m0 0L8 1m7 7-7 7"
  })));
};
export default SvgArrowRight;